<template>
  <v-notification :link="toSettings" :title="$t('title')" :details="$t('body')" actions warning>
    <template slot="actions">
      <v-tooltip bottom transition="fade-transition">
        <template v-slot:activator="{ on }">
          <v-btn small icon @click="verify" v-on="on">
            <v-icon small v-text="$vuetify.icons.values.check"></v-icon>
          </v-btn>
        </template>
        <span>{{ $t('labels.verify') }}</span>
      </v-tooltip>

      <v-tooltip bottom transition="fade-transition">
        <template v-slot:activator="{ on }">
          <v-btn small icon @click="resend" v-on="on">
            <v-icon small v-text="$vuetify.icons.values.reset"></v-icon>
          </v-btn>
        </template>
        <span>{{ $t('labels.resendLinks') }}</span>
      </v-tooltip>
    </template>
  </v-notification>
</template>

<script>
import { VNotification } from '@argon/app/components'
import VerifyMixin from './VerifyMixin'

export default {
  name: 'VerifyNotification',
  mixins: [VerifyMixin],
  components: {
    VNotification
  },
  methods: {
    toSettings() {
      this.$router.push({ name: 'me' })
    }
  }
}
</script>

<style scoped lang="scss">
.v-btn--icon {
  margin-right: 0;
  margin-left: 0;
}
</style>

<i18n>
{
  "en": {
    "body": "Please check your emails and text notifications and click on the verification links to validate and activate your account.",
    "title": "Your account is pending verification"
  },
  "fr": {
    "body": "Veuillez vérifier vos courriels et notifications textes et cliquer sur les liens de vérifications afin de les valider et activer votre compte.",
    "title": "Votre compte est en attente de vérification"
  }
}
</i18n>
